import { PipeTransform } from '@angular/core';
var ProducerCodePipe = /** @class */ (function () {
    function ProducerCodePipe() {
    }
    ProducerCodePipe.prototype.transform = function (producerCode) {
        return producerCode.substr(0, 2).concat('-').concat(('0000' + producerCode).substr(-4, 4));
    };
    return ProducerCodePipe;
}());
export { ProducerCodePipe };
